import { render } from "./IconCameraFilled.vue?vue&type=template&id=1e0a6c7b"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__